import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Tooltip,
  Input,
  Select,
  Radio,
  Checkbox,
  InputNumber
} from "antd";
import { Toggle } from "@ts-digital/vrc";
import "../style.css";
import DropZone from "../../../uploader/dropZone";
import SortableEl from "./sortableEl";
import { SortableContainer } from "react-sortable-hoc";
import { VaporDatePicker } from "../../../vapor";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";

const Option = Select.Option;

const SortableRadio = SortableContainer(item => {
  // return <Radio.Group disabled>{item.children}</Radio.Group>;
  return <div>{item.children}</div>;
});

const AskEditItem = props => {
  const {
    bodyItems,
    cn,
    item,
    preview,
    moveItem,
    onInputChange,
    setVisibleDeleteDialog,
    onSortEnd,
    isDots
  } = props;

  const intl = useIntl();

  const renderMultiple = item => {
    let items = [];
    let cn = 0;
    if (item.choices) {
      item.choices.map(value => {
        cn++;
        items.push({ label: value, value: cn });
        return items;
      });
    }
    return items;
  };

  return (
    <div
      key={"askEdit-item_" + item.id}
      className={`askEdit-item ${preview ? "preview" : ""}`}
    >
      <div className="askEdit-item-header">
        <div className="askEdit-item-header-context">
          {!preview && cn > 1 && (
            <Tooltip title="Sposta su" color={"rgb(0, 80, 117)"}>
              <FontAwesomeIcon
                onClick={() => moveItem(item.id, "up")}
                icon={["far", "chevron-up"]}
                style={{
                  display: bodyItems.length > 1 ? "" : "none"
                }}
              />
            </Tooltip>
          )}
          {!preview && cn < bodyItems.length && (
            <Tooltip title="Sposta giù" color={"rgb(0, 80, 117)"}>
              <FontAwesomeIcon
                onClick={() => moveItem(item.id, "down")}
                icon={["far", "chevron-down"]}
                style={{
                  display: bodyItems.length > 1 ? "" : "none"
                }}
              />
            </Tooltip>
          )}
          {preview && (
            <div className="askEdit-preview-numberQuestion">
              <FormattedMessage id="ask.builder.question" /> {!isDots ? item.id : cn}
            </div>
          )}
        </div>
        <div className="askEdit-item-header-remove">
          {!preview && (
            <FontAwesomeIcon
              icon={["far", "trash-alt"]}
              onClick={() => setVisibleDeleteDialog(item.id)}
            />
          )}
        </div>
      </div>
      {!preview ? (
        <div className="askEdit-item-body">
          <div className="askEdit-item-question">
            <div className="askEdit-item-label"><FormattedMessage id="ask.builder.question" /></div>
            <div className="askEdit-item-field">
              <Input
                maxLength={255}
                className="askEdit-widget-input"
                value={item.label}
                onChange={e => onInputChange(
                  "label", item.id, e.target.value
                )}
              />
            </div>
          </div>
          <div className="askEdit-item-tip">
            <div className="askEdit-item-label"><FormattedMessage id="ask.builder.info" /></div>
            <div className="askEdit-item-field">
              <Input.TextArea
                maxLength={255}
                className="askEdit-widget-input"
                placeholder={intl.formatMessage({ id: "ask.builder.tip" })}
                value={item.hint}
                onChange={e => onInputChange(
                  "hint", item.id, e.target.value
                )}
              />
            </div>
          </div>
          <div className="askEdit-item-type">
            <div className="askEdit-item-label"><FormattedMessage id="ask.builder.type" /></div>
            <div className="askEdit-item-field">
              <Select
                className="askEdit-widget-select"
                value={item.type}
                onChange={value => onInputChange(
                  "type", item.id, value
                )}
              >
                <Option value="input"><FormattedMessage id="ask.builder.types.text" /></Option>
                <Option value="date"><FormattedMessage id="ask.builder.types.date" /></Option>
                <Option value="currency"><FormattedMessage id="ask.builder.types.currency" /></Option>
                <Option value="number"><FormattedMessage id="ask.builder.types.number" /></Option>
                <Option value="file"><FormattedMessage id="ask.builder.types.file" /></Option>
                <Option value="boolean"><FormattedMessage id="ask.builder.types.yesno" /></Option>
                <Option value="checkbox"><FormattedMessage id="ask.builder.types.multiple" /></Option>
                <Option value="radio"><FormattedMessage id="ask.builder.types.single" /></Option>
              </Select>
              <div className={"askEdit-item-field-required"}>
                <span><FormattedMessage id="ask.builder.required" /></span>
                <span>
                  <Toggle
                    checked={item.isRequired || false}
                    onChange={value =>
                      onInputChange(
                        "isRequired", item.id, value
                      )
                    }
                  />
                </span>
              </div>
            </div>
          </div>
          {item.type === "checkbox" || item.type === "radio" ? (
            <div className="askEdit-item-multiple">
              <div className="askEdit-item-options">
                <SortableRadio
                  useDragHandle
                  onSortEnd={e => onSortEnd(item, e)}
                >
                  {item.choices.map((itm, index) => {
                    let cn = index;
                    return (
                      <SortableEl
                        key={`SortableEl_${index}`}
                        itm={itm}
                        cn={cn}
                        item={item}
                        index={index}
                        placeholderInput={intl.formatMessage({ id: "ask.builder.multiplePlaceholder" })}
                        conditionToRemove={cn > 0}
                        onInputChange={onInputChange}
                      />
                    );
                  })}
                </SortableRadio>
              </div>
            </div>
          ) : null}
        </div>
      ) : (
        <div className="askEdit-item-body">
          <div className="askEdit-item-question">
            <div className="askEdit-item-label">
              {item.label}{" "}
              {item.hint && item.hint.length > 0 && (
                <span className="askEdit-item-label-tip-icon">
                  <Tooltip title={item.hint} color={"rgb(0, 80, 117)"}>
                    <FontAwesomeIcon icon={["far", "question-circle"]} />
                  </Tooltip>
                </span>
              )}
            </div>
            <div className="askEdit-item-field">
              {item.type === "input" ? (
                <Input readOnly className="askEdit-widget-input" value="" />
              ) : item.type === "date" ? (
                <VaporDatePicker
                  getPopupContainer={(trigger) => trigger.parentNode}
                  disabled className="askEdit-widget-inputDate" />
              ) : item.type === "currency" ? (
                <InputNumber
                  value={""}
                  readOnly
                  className="askEdit-widget-inputNumber"
                  formatter={value =>
                    `€ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                  }
                  parser={value => value.replace(/\$\s?|(.*)/g, "")}
                  decimalSeparator={","}
                />
              ) : item.type === "number" ? (
                <InputNumber
                  value={""}
                  readOnly
                  size={"large"}
                  className="askEdit-widget-inputNumber"
                />
              ) : item.type === "textarea" ? (
                <Input.TextArea
                  readOnly
                  className="askEdit-widget-input"
                  value=""
                />
              ) : item.type === "file" ? (
                <DropZone disabled handleDrop={() => {}} />
              ) : item.type === "boolean" ? (
                <Radio.Group disabled>
                  <Radio value="yes"><FormattedMessage id="generic.yes" /></Radio>
                  <Radio value="no"><FormattedMessage id="generic.no" /></Radio>
                </Radio.Group>
              ) : item.type === "radio" ? (
                <SortableRadio onSortEnd={onSortEnd} useDragHandle>
                  {item.choices.map((itm, index) => {
                    let cn = index;
                    cn++;
                    return (
                      <SortableEl
                        key={`SortableEl2_${index}`}
                        itm={itm}
                        cn={cn}
                        item={item}
                        index={null}
                        placeholderInput="inserisci un'opzione"
                        conditionToRemove={cn > 1}
                        onInputChange={onInputChange}
                      />
                    );
                  })}
                </SortableRadio>
              ) : item.type === "checkbox" ? (
                <Checkbox.Group options={renderMultiple(item)} disabled />
              ) : null}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default AskEditItem;
